import { Help } from '@mui/icons-material'
import RuleCreate from './RuleCreate'
import RuleEdit from './RuleEdit'
import RuleList from './RuleList'

const ruleCatalogIndex = {
  icon: Help,
  list: RuleList,
  edit: RuleEdit,
  create: RuleCreate,
}

export default ruleCatalogIndex
